module.exports = __webpack_public_path__ + "static/media/gift1.d029401e.svg";